import { Injectable } from '@angular/core';

import DomainEventProvider from '../../../../../core/domain/events/domain_event_provider';
import { CreditEvent } from './credit-events';

@Injectable({ providedIn: 'root' })
export class CreditEventProvider extends DomainEventProvider<CreditEvent> {}
